import { SubscriptionSize } from "../SubscriptionSize.js";

export const subscriptionDiscountPercentForCzechiaPerSizeMap: Record<SubscriptionSize, number> = {
	[SubscriptionSize.G250x2]: 15,
	[SubscriptionSize.G250]: 5,
	[SubscriptionSize.Kg1]: 5,
};
